import { useState, useEffect } from 'react'

import { Textarea } from './textarea'

/**
 * Textarea that maintains it's own state and waits to report a change event to the parent component until a blur occurs
 */
export const BlurChangeTextarea = function ({ value, onChange, ...props }) {
  const [currentValue, setCurrentValue] = useState(value || '')

  useEffect(() => {
    setCurrentValue(value || '')
  }, [value])

  function handleChange (event) {
    setCurrentValue(event.target.value)
  }

  function callOnChange (event) {
    if (event.target.value !== value) {
      onChange(event)
    }
  }

  return <Textarea {...props} value={currentValue} onChange={handleChange} onBlur={callOnChange} />
}
